import { useContext } from 'react';
import { DeregistrationContext } from 'contexts/deregistrationContext/DeregistrationContext';

export const useDeregistrationContext = () => {
	return useContext(DeregistrationContext);
};
